import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const WebsiteIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Website",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M25.8 4.8H6.2A4.2 4.2 0 0 0 2 9v14a4.2 4.2 0 0 0 4.2 4.2h19.6A4.2 4.2 0 0 0 30 23V9a4.2 4.2 0 0 0-4.2-4.2M12.27 8.61v-.15c0-.47.38-.86.86-.86h.15c.47 0 .86.38.86.86v.15c0 .47-.38.86-.86.86h-.15a.86.86 0 0 1-.86-.86M9.54 7.6c.47 0 .86.38.86.86v.15c0 .47-.38.86-.86.86h-.15a.86.86 0 0 1-.86-.86v-.15c0-.47.38-.86.86-.86zM4.8 8.74v-.29c0-.47.38-.86.86-.86h.29c.41.06.73.41.73.84v.17c0 .47-.38.86-.86.86h-.17c-.43 0-.78-.31-.84-.72ZM27.2 23c0 .77-.63 1.4-1.4 1.4H6.2c-.77 0-1.4-.63-1.4-1.4V12.27h22.4z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M20.43 16.43v6.48l1.22-2.11c.21-.36.63-.53 1.03-.43l2.33.62-4.57-4.57Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M20.43 24.05a1.143 1.143 0 0 1-1.15-1.14v-6.48c0-.46.28-.88.71-1.06s.92-.08 1.25.25l4.57 4.57c.37.37.44.93.18 1.38s-.78.67-1.29.53l-2.16-.58-1.13 1.96c-.21.36-.59.57-.99.57Zm1.14-4.86v.21l.15-.06z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M28.43 29H3.29C1.4 29-.14 27.46-.14 25.57V15.28a1.14 1.14 0 1 1 2.28 0v10.29c0 .63.51 1.14 1.14 1.14h25.14c.63 0 1.14-.51 1.14-1.14V7.29c0-.63-.51-1.14-1.14-1.14H3.29c-.63 0-1.14.51-1.14 1.14v2.29h24a1.14 1.14 0 1 1 0 2.28H1c-.63 0-1.14-.51-1.14-1.14V7.29c0-1.89 1.54-3.43 3.43-3.43h25.14c1.89 0 3.43 1.54 3.43 3.43v18.29c0 1.89-1.54 3.43-3.43 3.43Z"
      })]
    })
  }));
};
WebsiteIcon.displayName = 'WebsiteIcon';